export const requestAccessFineLocationPermission = async () => true;
export const requestBluetoothConnectPermission = async () => true;
export const requestBluetoothScanPermission = async () => true;
export const requestCameraPermission = async () => true;
export const requestWriteExternalStoragePermission = async () => true;
export const requestReadExternalStoragePermission = async () => true;
export const requestCameraAndExternalStoragePermission = async () => (
  await requestCameraPermission()
    && await requestWriteExternalStoragePermission()
    && await requestReadExternalStoragePermission()
);
